const Axios = require("axios").default;
const CryptoJS = require("crypto-js");

function AuthManager() {

	var isBrowser = (typeof(localStorage) !== "undefined");

    var credentials = {
        LS_USER: 'SecurityManager.username',
        LS_KEY: 'SecurityManager.key',
		LS_ENCPWD: 'SecurityManager.encPwd',
		username:null,
		hash:null,
		encPwd:null,
        set: function (user, pwd) {
            // Set the username.
			this.username = (SecurityManager.appUser + user);
            // Set the key to a hash of the user's password + salt.
			this.hash = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256([CryptoJS.MD5(pwd), SecurityManager.salt].join(':'), SecurityManager.salt));
			if (SecurityManager.semiSecure){
				this.encPwd = CryptoJS.AES.encrypt(pwd, SecurityManager.salt).toString();
			}
			
			if (isBrowser){
				localStorage.setItem(this.LS_USER, this.username);
				localStorage.setItem(this.LS_KEY, this.hash);
				if (this.encPwd)
					localStorage.setItem(this.LS_ENCPWD, this.encPwd);
			}
            this.render();
        },
        user: function () { return !isBrowser? this.username : localStorage.getItem(this.LS_USER); },
        key: function () { return !isBrowser ? this.hash : localStorage.getItem(this.LS_KEY); },
		epwd: function () { return !isBrowser ? this.encPwd : localStorage.getItem(this.LS_ENCPWD); },
        render: function () {
            trace("credentials:user", this.user());
            trace("credentials:key", this.key());
			trace("credentials:epwd", this.epwd());
        },
        clear: function () {
			this.username = this.hash = null;
			if (isBrowser){
				localStorage.removeItem(this.LS_USER);
				localStorage.removeItem(this.LS_KEY);
				localStorage.removeItem(this.LS_ENCPWD);
			}
        }
    }
	
	trace = function (){
		if (SecurityManager.trace){
			console.log.apply(this, arguments);
		}
	}

    var SecurityManager = {
        salt: null, 
        ip: null,
        appUser: '',
        ipUrl: 'http://icanhazip.com/',
        logonUrl: 'logon',
		semiSecure: false,
		data: null,
		trace: false,
        init: function (appKey, settings) { 
			SecurityManager.salt = appKey;  
			if (typeof(settings) !== "undefined"){
				for(var p in settings)
					SecurityManager[p] = settings[p];
			}
		},
        generate: async function (username, password, ip, userAgent) {
            // Set the client IP address.
            SecurityManager.ip = ip || SecurityManager.ip || await SecurityManager.getIp();
			var ua = (userAgent || ((typeof(navigator)!=="undefined") ? navigator.userAgent : "")).replace(/ \.NET.+;/, '').replace(/ SLCC2;/, '');
            // Get the (C# compatible) ticks to use as a timestamp. http://stackoverflow.com/a/7968483/2596404
            var ticks = new Date().getTime() * 10000 + 621355968000000000;
			
            if (username && password) {
                // If the user is providing credentials, then create a new key.
                SecurityManager.logout();
                // set credentials
                credentials.set(username, password, ticks);
            }
            trace('sm:ip:' + SecurityManager.ip);
            trace('sm:nav:' + ua);
            // Construct the hash body by concatenating the username, ip, userAgent and ticks.
            var message = [credentials.user(), SecurityManager.ip, ua, ticks].join(':');
            // var message = [SecurityManager.username, SecurityManager.ip, ticks].join(':');
            // Hash the body, using the key.
            var hash = CryptoJS.HmacSHA256(message, credentials.key());
            // Base64-encode the hash to get the resulting token.
            var token = CryptoJS.enc.Base64.stringify(hash);
			if (!SecurityManager.semiSecure) token = "#"+token;
			trace(token);
			var transmittedPwd = SecurityManager.semiSecure ? ("~" + CryptoJS.AES.encrypt(credentials.epwd(), ""+ticks).toString()) : "";
			// Include the username and timestamp on the end of the token, so the server can validate.
			// if enabled transmission of pwd, bundle it with username 
			var tokenId = [credentials.user() + transmittedPwd, ticks].join(':');
            // Base64-encode the final resulting token.
            var tokenStr = CryptoJS.enc.Utf8.parse([token, tokenId].join(':'));
            return CryptoJS.enc.Base64.stringify(tokenStr);
        },
        logout: function (redirectToLogin) {
            credentials.clear();
            if (redirectToLogin && isBrowser)
                window.location.href = SecurityManager.logonUrl;
        },
        authenticate: function () {
			var key = credentials.key(); 
            if (!key && isBrowser)
                window.location.href = SecurityManager.logonUrl;
			return key ? true : false;
        },
        setData: function (json) {
			SecurityManager.data = JSON.stringify(json);
            if (isBrowser)
				localStorage['SecurityManager.userInfo'] = SecurityManager.data;
        },
        getData: function () {
            var s = !isBrowser ? SecurityManager.data : localStorage['SecurityManager.userInfo'];
            return JSON.parse(s);
        },
        /*getIp: function () {
            var xmlHttp = new XMLHttpRequest();
            xmlHttp.open("GET", SecurityManager.ipUrl, false); // false for synchronous request
            xmlHttp.send(null);
            return xmlHttp.responseText.trim();
        },*/
        getIp: async function () {
            const { data } = await Axios.get(this.ipUrl);
            return data.trim();
        }
    };
	
	return { 
		init: SecurityManager.init, 
		generate: SecurityManager.generate, 
		authenticate: SecurityManager.authenticate, 
		logout: SecurityManager.logout, 
		setData: SecurityManager.setData, 
		getData: SecurityManager.getData 
	};
}
const SecurityManager = new AuthManager();

module.exports = SecurityManager;

